export default __webpack_public_path__ + "static/media/6.308e0a06.jpeg";